import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Container, Divider, Grid, IconButton, InputAdornment, ListItem, Paper, TablePagination, TextField, Typography, makeStyles } from "@material-ui/core";
import { HeaderBlock } from '../../components/header-block/HeaderBlock';
import { useSelector, useDispatch } from 'react-redux';
import PageContainer from '../../components/page-container/PageContainer';
import { Loading } from '../../components/loading/Loading';
import { PagePlaceholder } from '../../components/page-placeholder/PagePlaceholder';
import SimpleTable from '../../components/table/Table';
import { getIcon } from '../../icon/icon';
import Search from '../../components/search/Search';
import { getDistributors } from '../../state/actions/DistributorsAction';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({

})

function ListOutOfStockPage(props) {
    const distributors = useSelector(state => state.DistributorReducer.distributors)

    const classes = useStyles()
    const [t, i18n] = useTranslation()

    const [loading, setLoading] = useState(false)
    const [originalData, setOriginalData] = useState(createData(distributors))
    const [searchedData, setSearchedData] = useState(createData(distributors))
    const [selected, setSelected] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        setLoading(true)
        dispatch(getDistributors(() => {
            setLoading(false)
        }))
    }, [])

    useEffect(() => {
        setSearchedData(createData(distributors))
        setOriginalData(createData(distributors))
    }, [distributors])

    function createData(outOfStockLists) {
        const outOfStockListKeys = Object.keys(distributors);

        return outOfStockListKeys.map(outOfStockListKey => {
            const outOfStockList = outOfStockLists[outOfStockListKey];
            return {
                id: outOfStockList.id,
                name: outOfStockList.DisplayName,

            };
        });
    }

    function createCells(headers) {
        let cells = [];

        headers.forEach(header => {
            let cell = {};

            cell.id = header.id;

            cell.handleClick = (event, row) => {
                props.history.push(`/out-of-stock/${row.id}`);
            };

            cell.align = header.align;
            cell.clickable = header.clickable;
            cell.type = header.type;

            cells.push(cell);
        });

        return cells;
    }

    function createHeaders() {
        return [
            {
                id: "name",
                clickable: true,
                align: "left",
                label: t('common.name'),
                type: "label"
            },
            {
                id: "id",
                clickable: false,
                align: "left",
                label: t('oos.out-of-stock-list-id'),
                type: "label"
            }
        ];
    }

    function renderTable() {
        const headers = createHeaders();
        const cells = createCells(headers);

        if (searchedData.length > 0) {
            return (
                <SimpleTable
                    isSelectable={true}
                    handleSelection={selectedItems => setSelected(selectedItems)}
                    dataId={"id"}
                    cells={cells}
                    headers={headers}
                    rows={searchedData}
                />
            );
        } else {
            return (
                <PagePlaceholder
                    image={getIcon("checkbox.svg")}
                    text={t('oos.none-found')}
                />
            );
        }
    }

    return (
        <Box>
            <HeaderBlock
                title={t('oos.out-of-stock-lists')}
                right={
                    <Grid container spacing={2} alignItems="center" justify="flex-end">
                        <Grid item>
                            <Search
                                searchField={"name"}
                                secondaryFields={["id"]}
                                returnSearchMatches={data => {
                                    setSearchedData(data)
                                }}
                                data={originalData}
                                searchTitle={t('oos.search')}
                            />
                        </Grid>
                    </Grid>
                }
            />

            <PageContainer hasFooter>
                {loading ? <Loading /> : renderTable()}
            </PageContainer>
        </Box >
    )
}

ListOutOfStockPage.propTypes = {

}

export default ListOutOfStockPage
